import React, { useState } from "react";
import { Card, Flex, Text, Button, Badge, Dialog } from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";
import { useProfileContext } from "context";
import { useGetTripadvisorReviewsStatus } from "hooks";
import { PermissionAlertDialog } from "components";

export function BrowseTripadvisorReviewsCard({ userProfile }) {
  const navigate = useNavigate();
  const { userProfile: ctxProfile } = useProfileContext();
  const profile = userProfile || ctxProfile;

  const [showPermissionAlert, setShowPermissionAlert] = useState(false);
  const [showInfoDialog, setShowInfoDialog] = useState(false);

  const { data: statusData, isLoading: isStatusLoading } = useGetTripadvisorReviewsStatus(profile?.organisation_id);

  const isActive = () => {
    if (isStatusLoading) return false;
    return statusData?.data?.status === "active";
  };

  const handleConnectClick = () => {
    const isOwner = profile?.user_role === "Owner";
    if (!isOwner) {
      setShowPermissionAlert(true);
      return;
    }
    setShowInfoDialog(true);
  };

  const handleContinue = () => {
    setShowInfoDialog(false);
    navigate("/tripadvisor-reviews-setup", {
      state: {
        orgId: profile?.organisation_id,
        isManaging: isActive(),
      },
    });
  };

  return (
    <>
      <Card
        style={{
          display: "flex",
          width: "100%",
          padding: "var(--space-4)",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Flex align="center" gap="4">
          <Flex
            style={{
              borderRadius: "var(--space-1)",
              background: "#FFFFFF",
              border: "1px solid var(--gray-a6)",
            }}
            height="40px"
            width="40px"
            p="2"
            justify="center"
            align="center"
          >
            <img
              src={require("../../../assets/images/tripadvisor.png")}
              alt="TripAdvisor"
              style={{ width: "24px" }}
            />
          </Flex>
          <Flex direction="column" justify="center" align="start">
            <Text size="4" weight="medium">
              Tripadvisor
            </Text>
            <Text style={{ color: "var(--gray-a11)" }} size="1">
              Customer reviews
            </Text>
          </Flex>
        </Flex>

        <Flex align="center">
          {isActive() ? (
            <Badge size="1" variant="soft" color="green">
              Connected
            </Badge>
          ) : (
            <Button onClick={handleConnectClick} size="2" variant="soft" color="gray">
              Connect
            </Button>
          )}
        </Flex>
      </Card>

      <PermissionAlertDialog
        isOpen={showPermissionAlert}
        onOpenChange={setShowPermissionAlert}
        message="Only owners can perform this action"
      />

      <Dialog.Root open={showInfoDialog} onOpenChange={setShowInfoDialog}>
        <Dialog.Content maxWidth="520px">
          <Dialog.Title>Connect Tripadvisor</Dialog.Title>
          <Dialog.Description size="2" mb="4">
            To sync Tripadvisor reviews, paste the venue page URL for each location you want to map.
          </Dialog.Description>

          <Flex direction="column" gap="2" mb="4">
            <Text size="2" color="gray">
              Example URL:
            </Text>
            <Text size="2" style={{ color: "var(--gray-a11)" }}>
              https://www.tripadvisor.com/Restaurant_Review-...html
            </Text>
          </Flex>

          <Flex gap="3" justify="end">
            <Dialog.Close>
              <Button variant="soft" color="gray">
                Cancel
              </Button>
            </Dialog.Close>
            <Button onClick={handleContinue}>Continue</Button>
          </Flex>
        </Dialog.Content>
      </Dialog.Root>
    </>
  );
}
